<template>
  <div id="setup_chat2pay" style="height: 100vh; overflow-y: auto;">
    <div>
      <template v-if="loading">
        <div class="loading_container">
          <scale-loader :color="$vuetify.theme.primary" height="45px" width="7px"></scale-loader>
        </div>
      </template>
      <template v-else>
        <template v-if="computedPage.length == 0">
          <div class="container text-xs-center">
            <div class="row">
              <div class="col s12 m6 offset-m3">
                <img src="/static/img/assets/get_started/no_page.png" alt class="responsive-img" />
                <h5>{{ $t('You dont have any Facebook page or') }}</h5>
                <h5>{{ $t('No permission to access Facebook page') }}</h5>

                <a
                  href="https://www.facebook.com/pages/creation/"
                  target="_blank"
                  class="btn"
                  style="width: 100%; margin-bottom: 15px;"
                  >{{ $t('If you dont have any Facebook page, Create new page') }}</a
                >
                <p>{{ $t('or') }}</p>
                <a href="javascript:void(0);" @click="logout" class="btn" style="width: 100%">{{
                  $t('If you have page, Login again and Allow Facebook page permission')
                }}</a>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <template v-if="currentView == 'select-page'">
            <nav style="background: transparent;box-shadow: none;">
              <div class="nav-wrapper">
                <div
                  class="left"
                  style="padding-left: 15px;"
                  v-if="$route.query.source && $route.query.source == 'zwiz'"
                >
                  <router-link
                    :to="'/' + currentLang + '/allbot'"
                    class="btn btn-flat"
                    style="margin-bottom: 15px;"
                  >
                    <span class="fas fa-chevron-left"></span>
                    ย้อนกลับ
                  </router-link>
                </div>
                <div class="right" style="padding-right: 15px;">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-flat"
                    style="margin-bottom: 15px;"
                    @click="logout"
                    >ลงชื่อออก</a
                  >
                </div>
              </div>
            </nav>
            <div class="text-xs-center">
              <transition name="fade" mode="out-in">
                <h4 style="margin-bottom: 25px;">
                  เลือกเพจเพื่อติดตั้ง CHAT2PAY
                  <!-- <template v-if="themelist.length > 0">
                      <span>{{themelist[0].themename}}</span>
                  </template>-->
                </h4>
              </transition>
            </div>

            <div class="pages">
              <transition-group
                v-bind:css="false"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-on:leave="leave"
              >
                <div v-for="(page, index) in computedPage" :key="'page_' + page.id">
                  <div>
                    <page-item
                      v-model="computedPage[index]"
                      class="page"
                      :class="{
                        active: page.gbprime_status == true,
                        inactive: page.gbprime_status == false
                      }"
                    >
                      <template slot="page-status">
                        <div class="status">
                          <template v-if="page.gbprime_status == true"
                            >เปิดการใช้งาน</template
                          >
                          <template v-else-if="page.gbprime_status == false"
                            >ปิดการใช้งาน</template
                          >
                          <template v-else
                            >ยังไม่ได้ติดตั้ง</template
                          >
                        </div>
                      </template>
                      <div
                        slot="select-page"
                        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; "
                        @click="onSelectPage(page)"
                      ></div>
                    </page-item>
                  </div>
                </div>
              </transition-group>
            </div>
          </template>
          <template v-else-if="currentView == 'setup'">
            <nav style="background: transparent;box-shadow: none;">
              <div class="nav-wrapper">
                <div class="left" style="padding-left: 15px;">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-flat"
                    style="margin-bottom: 15px;"
                    @click="goBack"
                  >
                    <span class="fas fa-chevron-left"></span>
                    ย้อนกลับ
                  </a>
                </div>
                <div class="right" style="padding-right: 15px;">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-flat"
                    style="margin-bottom: 15px;"
                    @click="logout"
                    >ลงชื่อออก</a
                  >
                </div>
              </div>
            </nav>
            <div class="text-xs-center">
              <div v-if="currentPage">
                <img
                  class="responsive-img circle"
                  alt
                  @error="onError"
                  :src="
                    'https://graph.facebook.com/' +
                      currentPage.id +
                      '/picture?width=100&height=100&SameSite=None'
                  "
                  style="border: 1px solid #eee; width: 100px; height: 100px;"
                />
                <div>{{ currentPage.name_with_location_descriptor }}</div>
              </div>
              <transition name="fade" mode="out-in">
                <h4 style="margin-bottom: 25px;">วิธีการใช้งาน Chat2Pay</h4>
              </transition>
            </div>

            <div>
              <div class="container">
                <carousel :items="1" :autoHeight="true" :nav="false">
                  <div class="text-xs-center">
                    <img
                      src="/static/img/assets/chat2pay/step1.png"
                      alt
                      class="responsive-img"
                      style="border-radius: 10px; border: 1px solid #eee; max-width: 600px; margin: auto"
                    />
                    <p style="margin-top: 15px; margin-bottom: 0">
                      สมัครสมาชิกเพื่อรับเงินผ่าน GB Prime Pay ที่
                      <a
                        href="https://www.gbprimepay.com/register"
                        target="_blank"
                        rel="noopener noreferrer"
                        >https://www.gbprimepay.com/register</a
                      >
                      กรอกข้อมูล และ
                      <span class="primary-color"
                        >ลูกค้าต้องกรอก รหัสอ้างอิง (Ref): "chat2pay" เพื่อได้เรทการชำระเงินแบบพิเศษ
                        (ชำระบัตรเครดิต ค่าธรรมเนียม 2.9% และชำระผ่าน QR Code 0.5%)</span
                      >
                      หลังจากนั้นรอ 1-3 วัน และเข้าหน้า Profile เพื่อรับ token
                    </p>
                  </div>
                  <div class="text-xs-center">
                    <img
                      src="/static/img/assets/chat2pay/step2.png"
                      alt
                      class="responsive-img"
                      style="border-radius: 10px; border: 1px solid #eee; max-width: 600px; margin: auto"
                    />
                    <p style="margin-top: 15px; margin-bottom: 0">
                      นำ token ที่ได้จากหน้า Profile (
                      <a
                        href="https://www.gbprimepay.com/merchant/profile"
                        target="_blank"
                        rel="noopener noreferrer"
                        >https://www.gbprimepay.com/merchant/profile</a
                      >) มากรอกที่กล่องด้านล่าง และ กดบันทึก
                    </p>
                  </div>
                  <div class="text-xs-center">
                    <img
                      src="/static/img/assets/chat2pay/step3.png"
                      alt
                      class="responsive-img"
                      style="border-radius: 10px; border: 1px solid #eee; max-width: 600px; margin: auto"
                    />
                    <p style="margin-top: 15px; margin-bottom: 0">
                      เริ่มต้นใช้งาน Chat2Pay ได้เลย โดยแอดมินเพจพิมพ์หาลูกค้าว่า เปิดบิล
                      ตามด้วยรายละเอียดและราคา ระบบจะส่งลิ้งจ่ายเงินไปให้ลูกค้าทันที
                      <span class="primary-color">เงินจะเข้าบัญชีทุกวันจันทร์ พุธ และศุกร์</span>
                    </p>
                  </div>
                </carousel>

                <div class="text-xs-center" style="font-size: 12px;">
                  <p>
                    หมายเหตุ: หากติดปัญหาการสมัครสมาชิกรบกวนโทร +66-2645-3781, +66-2248-6397-99,
                    +6692-436-3481 (24 ชั่วโมง)
                  </p>
                </div>
              </div>
              <div class="text-xs-center">
                <div class="hr"></div>
                <div class="container">
                  <transition name="fade" mode="out-in">
                    <h4 style="margin-bottom: 25px;">กรอก GB Prime Token</h4>
                  </transition>
                  <div class="form-control" :class="{ 'has-error': errors.has('gbPrimeToken') }">
                    <textarea
                      cols="30"
                      rows="10"
                      style="min-height: 90px;"
                      v-model="token"
                      placeholder="ใส่ GB Prime Token"
                      name="gbPrimeToken"
                      data-vv-as="GB Prime Token"
                      v-validate="'required'"
                    ></textarea>
                    <span class="text-error" v-if="errors.has('gbPrimeToken')"
                      >กรุณากรอก GB Prime Token</span
                    >
                    <div style="margin-top: 15px;">
                      <a href="javascript:void(0);" class="btn" @click="onSaveToken">บันทึก</a>
                    </div>
                  </div>
                </div>
                <template v-if="currentPage.gbprime_token">
                  <div class="hr" style="margin-top: 15px; margin-bottom: 15px;"></div>

                  <div class="container">
                    <div class="row" v-if="currentPage">
                      <div class="col s6 left-align">
                        {{ currentPage.gbprime_status ? 'เปิดการใช้งานอยู่' : 'ปิดการใช้งานอยู่' }}
                      </div>
                      <div class="col s6 right-align">
                        <label
                          class="toggle-switch small"
                          style="margin-top: 10px;vertical-align: bottom;"
                        >
                          <input
                            type="checkbox"
                            :checked="currentPage.gbprime_status"
                            @change="onToggleChat2Pay()"
                          />
                          <span class="toggle-slider lever round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import Velocity from 'velocity-animate'
import { mapGetters } from 'vuex'
import PageItem from '@/components/view/allbots/PageItem'
import LangDropdown from '@/components/elements/LangDropdown'
import carousel from 'vue-owl-carousel'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import ModalDialog from '@/components/elements/ModalDialog'

export default {
  data: function() {
    return {
      currentView: 'select-page',
      stage: 'select-page',
      currentPageIndex: null,
      currentPage: null,
      themelist: [],
      selectedTheme: undefined,
      token: undefined,
      gbprime_pages: [],
      errorMessage: null,
      loading: true,
      showHowToUse: false
    }
  },
  components: {
    PageItem,
    LangDropdown,
    carousel,
    ScaleLoader,
    ModalDialog
  },
  mounted: function() {
    let vm = this
    vm.loading = true
    vm.getAllPublicTheme(function() {
      vm.selectedTheme = vm.themelist[0]
      vm.getGBprimePages(function() {
        vm.loading = false
      })
    })
  },
  computed: {
    ...mapGetters({
      botlist: 'botlist',
      pagelist: 'allPage',
      currentLang: 'currentLang'
    }),
    computedPage: function() {
      var vm = this
      var pages = []
      if (vm.pagelist) {
        if (vm.gbprime_pages.length === 0) {
          return pages
        }
        vm.pagelist.map(function(page, index) {
          let gbprime = vm.gbprime_pages.find(function(el) {
            return el.pageid === page.id
          })
          if (gbprime) {
            page.gbprime_status = gbprime.gbprime_status
            page.gbprime_token = gbprime.gbprime_token
            pages.push(page)
          } else {
            page.gbprime_status = null
            page.gbprime_token = null
            pages.push(page)
          }
        })
      }
      return pages
    }
  },
  methods: {
    getAllPublicTheme: function(callback) {
      let vm = this
      api.getAllPublicTheme({ appid: config.appid }, function(error, response) {
        if (error) {
          console.error(error)
          return
        }

        vm.themelist = response.data
        callback()
      })
    },
    onToggleChat2Pay: function() {
      var vm = this
      if (!vm.currentPage || (vm.currentPage && !vm.currentPage.gbprime_token)) {
        return
      }
      vm.$store.dispatch('loading')
      var data = {
        pageid: vm.currentPage.id,
        gbprime_status: !vm.currentPage.gbprime_status,
        gbprime_token: vm.currentPage.gbprime_token
      }
      api.saveGbprime(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.currentPage.gbprime_status = !vm.currentPage.gbprime_status
        vm.gbprime_pages.map(function(page, index) {
          if (page.pageid === vm.currentPage.id) {
            vm.gbprime_pages[index].gbprime_status = vm.currentPage.gbprime_status
            return false
          }
        })
        vm.$store.dispatch('loading')
      })
    },
    onSelectPage: function(page) {
      var vm = this
      if (page.gbprime_token) {
        vm.token = page.gbprime_token
      }
      vm.currentView = 'setup'
      vm.currentPageIndex = page.id
      vm.currentPage = page
      vm.$nextTick(function() {
        $('#setup_chat2pay').animate({ scrollTop: 0 })
      })
    },
    getGBprimePages: function(callback) {
      var vm = this
      var pages = []
      if (vm.pagelist) {
        vm.pagelist.map(function(page) {
          if (page.isInstallBot) {
            pages.push(page.id)
          }
        })
      }

      var data = {
        pageid: pages.join(',')
      }

      api.getGbprime(data, function(error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        vm.gbprime_pages = response.data
        callback()
      })
    },
    logout: function() {
      var vm = this
      vm.$store.dispatch('logout', null).then()
      vm.$router.push(vm.$router.push('/' + vm.currentLang + '/chat2pay'))
    },
    onError: function() {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    onSaveToken: function() {
      var vm = this
      if (vm.currentPage) {
        vm.$validator.validate().then(result => {
          if (!result) {
            // do stuff if not valid.
            vm.goToErrorInput()
            return false
          }
          api.checkGBprimeToken({ token: vm.token }).then(
            function() {
              if (vm.currentPage.isInstallBot) {
                vm.$store.dispatch('loading')
                vm.currentPage.gbprime_status = true
                var data = {
                  pageid: vm.currentPage.id,
                  gbprime_status: true,
                  gbprime_token: vm.token
                }
                api.saveGbprime(data, function(error, response) {
                  if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
                  }
                  vm.currentPage.gbprime_token = vm.token
                  var isFound = false
                  vm.gbprime_pages.map(function(page, index) {
                    if (page.pageid === vm.currentPage.id) {
                      isFound = true
                      vm.gbprime_pages[index].gbprime_status = vm.currentPage.gbprime_status
                      vm.gbprime_pages[index].gbprime_token = vm.currentPage.gbprime_token
                      return false
                    }
                  })
                  if (!isFound) {
                    vm.gbprime_pages.push(data)
                  }
                  vm.$store.dispatch('loading')
                  vm.$swal.fire({
                    title: vm.$t('ติดตั้ง CHAT2PAY เรียบร้อย'),
                    type: 'success',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('cancel'),
                    reverseButtons: true
                  })
                })
              } else {
                vm.onSubscribeBot(vm.token)
              }
            },
            function(e) {
              vm.$swal.fire({
                title: vm.$t('GB Prime Token ไม่ถูกต้อง'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('cancel'),
                reverseButtons: true
              })
            }
          )
        })
      }
    },
    onSubscribeBot: function(token) {
      if (this.currentPageIndex == null) {
        return
      }
      let vm = this
      let page = this.currentPage
      let data = {
        pageid: page.id,
        page_access_token: page.access_token,
        theme: this.selectedTheme.themeid,
        pagename: page.name,
        ownerid: this.$store.state.userid,
        status: false,
        gbprime_status: true,
        gbprime_token: token,
        facebook_name: this.$store.state.facebook_name
      }
      vm.$store.dispatch('loading')
      api.newSubscribe(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        vm.$store.dispatch('updateNewBotlist').then(
          function() {
            vm.currentPage.gbprime_status = true
            vm.currentPage.gbprime_token = vm.token
            var isFound = false
            vm.gbprime_pages.map(function(page, index) {
              if (page.pageid === vm.currentPage.id) {
                isFound = true
                vm.gbprime_pages[index].gbprime_status = vm.currentPage.gbprime_status
                vm.gbprime_pages[index].gbprime_token = vm.currentPage.gbprime_token
                return false
              }
            })
            if (!isFound) {
              vm.gbprime_pages.push({
                pageid: page.id,
                gbprime_status: vm.currentPage.gbprime_status,
                gbprime_token: vm.currentPage.gbprime_token
              })
            }
            vm.$store.dispatch('loading')

            vm.$swal.fire({
              title: vm.$t('ติดตั้ง Chat2Pay เรียบร้อย'),
              type: 'success',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
          },
          function(e) {
            vm.$store.dispatch('loading')
            vm.errorMessage = 'Can not update chatbot'

            vm.$swal.fire({
              title: vm.$t('ติดตั้ง Chat2Pay ไม่สำเร็จ'),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
          }
        )
      })
    },
    goBack: function() {
      var vm = this
      vm.currentPageIndex = null
      vm.currentPage = null
      vm.token = null
      vm.currentView = 'select-page'
    },
    beforeEnter: function(el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/chat2pay/SetupC2p.vue